<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      show-footer
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :footer-method="() => footerData"
      :height="tableHeight"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <div class="p-2">
          <BatchSkuTable :amzPurchaseBatchCode="row.amzPurchaseBatchCode" />
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import BatchSkuTable from '../batch-sku-table'
export default {
  mixins: [TableAutoHeight],
  components: { BatchSkuTable },
  props: {
    tableData: { type: Array, default: () => [] },
    totalData: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = this.totalData[t.field]
          return val ? format(val) : '0'
        })
      result[1] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
}
</script>
